import { isEmpty } from '@/helper/funcoes';
import { defineStore } from 'pinia';

export const useAcessoValidoStore = defineStore('acessoValido', {
    state: () => ({
        acessoValido: false,
    }),
    actions: {
        salvar(idAtendimento, valido) {
            this.acessoValido = valido;
            localStorage[`acessoValido${idAtendimento}`] = valido;
        },

        verificaLocalStorage(idAtendimento) {
            if (idAtendimento) {
                /* if (process.env.NODE_ENV == 'development') {
                    this.salvar(idAtendimento, true);
                } */
                
                const valido = localStorage['acessoValido' + idAtendimento];
                if (!isEmpty(valido)) {
                    this.salvar(idAtendimento, JSON.parse(valido));
                }
            }

            return this.acessoValido;
        }
    }
});